// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7bFSt","field":"styles_field__r8aRq","fieldCol":"styles_fieldCol__nHmsy","diffCol":"styles_diffCol__1g8HD","diff":"styles_diff__2rw-S"};